module.exports = __webpack_public_path__ + "static/media/play.effe2a6b.png";